module.exports = __webpack_public_path__ + "img/bg-image-4.29238c1d.jpg";